export const numberOfReminders: number = 10
